import { INofiticationRequest } from "../../../model/request/nofitication/INofiticationRequest";
import { INotificationActionTypes } from "../../action-types/nofitication/INofiticationActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { INotificationReducer } from "../../reducer-model/notification/INotificationReducer";
const iniState: INotificationReducer = {
  isShow: false,
  notifications: [],
  readStatus: "all",
  status: eReducerStatusBase.is_not_initialization,
  request: {} as INofiticationRequest,
};
export const nofiticationReducer = (
  state: INotificationReducer = iniState,
  action: INotificationActionTypes,
): INotificationReducer => {
  switch (action.type) {
    case "NOFITICATION_CHANGE_READ_STATUS":
      return {
        ...state,
        readStatus: action.payload,
      };
    case "NOFITICATION_CHANGE_SHOW":
      return {
        ...state,
        isShow: action.payload,
      };
    default:
      return state;
  }
};
